module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-mansion-7c7c1c0510eff94fc2bf0c96d1c1ff7d.svg";